"use strict";

import { auth } from "./auth.reducer";

import { successMessageReducer, errorMessageReducer } from "./message.reducer";
import { loadingSpinnerReducer } from "./loading.spinner.reducer";
import { dashboard } from "./dashboard.reducer";
import { lookupTable } from "./lookupTable.reducer";
import { factTable } from "./factTable.reducer";
import { dataUpload } from "./dataUpload.reducer";
import { incentive } from "./incentive.reducer";
import { dataTemplate } from "./dataTemplate.reducer";
import { participants } from "./participant.reducer";
import { retailSales } from "./retailSales.reducer";
import { cxAlwaysInTouch } from "./cxAlwaysInTouch.reducer";
import { optimumFriction } from "./optimumFriction.reducer";
import { lcvParticipants } from "./lcvParticipants.reducer";
import { lcvPrizePot } from "./lcvPrizePot.reducer";
import { lcvCampaign } from "./lcvCampaign.reducer";
import { lcvManualPrizeWins } from "./lcvManualPrizeWins.reducer";
import { lcvReports } from "./lcvReports.reducer";
import { lcvOrders } from "./lcvOrders.reducer";

export default {
     config: {
          imageUploadBaseUrl: ""
               // process?.env?.SERVICES_API_IMAGE_UPLOAD_BASE_URL || "",
     },
     auth,

     loading: loadingSpinnerReducer,
     successMessage: successMessageReducer,
     errorMessage: errorMessageReducer,
     dashboard,
     lookupTable,
     factTable,
     dataUpload,
     incentive,
     dataTemplate,
     participantsManagement:participants,
     retailSales,
     cxAlwaysInTouch,
     optimumFriction,
     lcvParticipants,
     lcvPrizePot,
     lcvCampaign,
     lcvManualPrizeWins,
     lcvReports,
     lcvOrders
};
